<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e7TsS1/tc-custom/9781644570159.jpg?1685327318019" alt="This image is the cover for the book Forbidden to Love (Author's Cut Edition)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forbidden to Love (Author's Cut Edition)
      </h1>
      <p class="bookDescription body article font2">
        <b>A Blinded Woman Recovers Her Sight and Loses Her Heart in <i>Forbidden to Love</i> a Civil-War Era Historical Romance by Patricia Hagan</b><br/><br/><i>--1858-65, New Orleans, Louisiana and London, England--</i><br/><br/>Anjele Sinclair, daughter of a wealthy plantation owner, falls in love with a lowly field hand only to be disgraced by his betrayal. At her father's bidding she leaves the plantation for school in England, hoping to forget her foolishness.<br/><br/>Returning four years later, the Civil-War rages and her mother is dead. When she witnesses the murder of her father, her attacker wields a blow, leaving her completely blind.<br/><br/>Now, sightless and alone amidst the Civil-War, Brett Cody--a Yankee soldier--comes to her aid. As the two struggle to survive the conflict of war, Anjele falls helplessly in love with her savior. But when her sight returns, a bittersweet reality awaits.<br/><br/><b>Publisher's Note:</b> This is an Author's Cut edition of a work previously published as <b>HEAVEN IN A WILDFLOWER.</b> It has been revised and updated for today's audience. Contains graphic sexual situations and violence in keeping with the horrors of the civil-war era. This story will be enjoyed by fans of <b>Scarlett Scott, Kathryn Kelly, Paula Millet, Kathleen E. Woodiwiss</b> and <b>Gone with the Wind.</b><br/><br/><b>THE SOULS AFLAME SERIES</b> by Patricia Hagan<br/><i>This Rebel Heart<br/>This Savage Heart</i><br/><br/><b>OTHER TITLES</b> by Patricia Hagan<br/><i>Say You Love Me<br/>Starlight<br/>Simply Heaven<br/>Orchids in Moonlight<br/>Final Justice<br/>Forbidden to Love<br/>Passion's Fury<br/></i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Hagan
      </h2>
      
      <p class="authorDescription body article">Patricia Hagan is a New York Times bestselling author of 42 novels, proud mother of a U.S. Navy SEAL and is a native of Alabama.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a046e75